module.exports = __webpack_public_path__ + "img/18 Aniamtion 3-squashed.5a453e74.jpg";